export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    template: [
        'RESOURCE_TEMPLATE',
        data => ({
            id: data.id,
            name: data.file_name,
            isFolder: !Boolean(data.download_url),
            thumbnail: data.thumbnail,
            description: data.description,
            parent: data.parent,
            downloadUrl: data.download_url,
            createdAt: data.created_at,
            updatedAt: data.updated_at,
            organizations: data.organizations,
            public: data.public,
            content: data.content,
            nodeType: data.node_type,
            isSystemResource: data.is_system_resource,
            order: data.order,
        }),
    ],
    authorize: true,

    '/nodes': {
        GET: {
            entry: res => {
                return res.data.results || [];
            },
        },
        '/:id': {
            GET: {},
        },
    },
    '/folder': {
        GET: {},
        '/:id': {
            GET: {},
        },
    },
};
